import { Binoculars, CalendarDays, Feather, MapPin } from "lucide-react";
import { STATS } from "./data";
import { Reveal } from "./Reveal";

const ICONS = { MapPin, CalendarDays, Binoculars, Feather };

export default function Stats() {
  return (
    <section data-testid="stats-section" className="border-t border-ivory/10 bg-forest">
      <div className="mx-auto grid max-w-editorial grid-cols-2 gap-y-10 px-6 py-14 md:grid-cols-4 md:px-10 md:py-16">
        {STATS.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal
              key={s.label}
              delay={i * 0.1}
              className="flex flex-col items-center gap-2 text-center md:border-l md:border-ivory/10 md:first:border-l-0"
            >
              <Icon className="mb-1 h-5 w-5 text-saffron" strokeWidth={1.5} />
              <span data-testid={`stat-value-${i}`} className="font-serif text-2xl font-light text-ivory md:text-3xl">
                {s.value}
              </span>
              <span className="text-[10px] font-medium uppercase tracking-[0.26em] text-ivory/50">{s.label}</span>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
